import { render } from "./NotificationConfig.vue?vue&type=template&id=35580856&scoped=true"
import script from "./NotificationConfig.vue?vue&type=script&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&lang=js"

import "./NotificationConfig.vue?vue&type=style&index=0&id=35580856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35580856"]])

export default __exports__